// Dynamic import defers app startup until the Module Federation container has
// finished negotiating shared modules (react, react-dom, react-router-dom).
// Without this, named exports from shared packages arrive as undefined when
// the shell is also a MF host declaring those packages as singletons.
import('./bootstrap')
